
import React from 'react';

const WhyChooseSection: React.FC = () => {
  return (
    <section className="section-padding bg-white">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Why Choose Our Consulting Services</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our approach to IT consulting is built on a foundation of business understanding and practical solutions.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="bg-itmgmt-light-gray p-6 rounded-lg">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">1</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Vendor-Neutral Expertise</h3>
            <p className="text-gray-600">
              We provide unbiased recommendations based on your specific needs, not vendor incentives.
            </p>
          </div>
          
          <div className="bg-itmgmt-light-gray p-6 rounded-lg">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">2</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Business-First Approach</h3>
            <p className="text-gray-600">
              We focus on business outcomes rather than technology for technology's sake.
            </p>
          </div>
          
          <div className="bg-itmgmt-light-gray p-6 rounded-lg">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">3</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Practical Solutions</h3>
            <p className="text-gray-600">
              We deliver actionable recommendations with clear implementation plans, not just theoretical advice.
            </p>
          </div>
          
          <div className="bg-itmgmt-light-gray p-6 rounded-lg">
            <div className="bg-itmgmt-medium-blue rounded-full h-12 w-12 flex items-center justify-center mb-4">
              <span className="text-white font-bold">4</span>
            </div>
            <h3 className="font-bold text-itmgmt-dark-blue text-xl mb-4">Long-term Partnership</h3>
            <p className="text-gray-600">
              We build lasting relationships to support your evolving technology needs as your business grows.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseSection;
